// *************************** Import CSS *************************** //

import '@styles/main.scss';
import "./sc2025-feature.css";

// *************************** Import Images *************************** //

// ** Icons ** //
import "/src/assets/icons/purple-play-button.png";
import "/src/assets/icons/purple-play-button.png";
// import "/src/assets/icons/arrow.svg";
import "/src/assets/icons/swipe-arrow.svg";

// ** GCS Team Photo ** //
// import "/src/assets/summer-camp-2025/gcs-team-photo-sc2025.jpg";
// import "/src/assets/summer-camp-2025/gcs-team-photo-sc2025-fun.jpg";

// ** Partners & Sponsors ** //
// import "/src/assets/sponsor-logos/live-oak-public-libraries.png";
// import "/src/assets/sponsor-logos/emory-photography-logo.jpg";

// ** LOPL Logo ** //
// import "/src/assets/sponsor-logos/LOPL/lopl-full-round-logo-2026.png";

// ** FP Images ** //
// import "/src/assets/summer-camp-2025/foiled-pretty-iphone-screenshot.jpg";
// import "/src/assets/summer-camp-2025/foiled-pretty-laptop.png";
// import "/src/assets/summer-camp-2025/foiled-pretty-small.png";



// ****************************** JS - Photo/Video Gallery ******************************** //

document.addEventListener('DOMContentLoaded', () => {
  const track = document.getElementById('track');
  const preBtn = document.getElementById('preBtn');
  const nxtBtn = document.getElementById('nxtBtn');
  const cards = document.querySelectorAll('.product-card');

  // Safety exit boundary condition check
  if (!track || !preBtn || !nxtBtn || cards.length === 0) return;

  let currentTranslateX = 0;

  // Dynamically calculate metrics to completely drop old matchMedia hardcodings
  function getCarouselMetrics() {
    const firstCard = cards[0];
    const cardWidth = firstCard.getBoundingClientRect().width;
    
    // Auto-calculates gaps directly computed via the browser layout rendering models
    const computedGap = parseFloat(window.getComputedStyle(track).gap) || 0;
    const stepShift = cardWidth + computedGap;
    
    const trackVisibleWidth = track.parentElement.getBoundingClientRect().width;
    const maxScrollLeft = track.scrollWidth - trackVisibleWidth;

    return { stepShift, maxScrollLeft };
  }

  function updateSliderControls(maxScrollLeft) {
    preBtn.style.display = currentTranslateX >= 0 ? "none" : "flex";
    nxtBtn.style.display = Math.abs(currentTranslateX) >= maxScrollLeft ? "none" : "flex";
  }

  // Next Trigger Click Listener Execution Block
  nxtBtn.addEventListener('click', () => {
    const { stepShift, maxScrollLeft } = getCarouselMetrics();
    currentTranslateX -= stepShift;
    
    if (Math.abs(currentTranslateX) > maxScrollLeft) {
      currentTranslateX = -maxScrollLeft;
    }

    track.style.transform = `translateX(${currentTranslateX}px)`;
    updateSliderControls(maxScrollLeft);
  });

  // Previous Trigger Click Listener Execution Block
  preBtn.addEventListener('click', () => {
    const { stepShift, maxScrollLeft } = getCarouselMetrics();
    currentTranslateX += stepShift;
    
    if (currentTranslateX > 0) {
      currentTranslateX = 0;
    }

    track.style.transform = `translateX(${currentTranslateX}px)`;
    updateSliderControls(maxScrollLeft);
  });

  // Recalculates metrics automatically on screen rotations instantly
  window.addEventListener('resize', () => {
    const { maxScrollLeft } = getCarouselMetrics();
    if (Math.abs(currentTranslateX) > maxScrollLeft) {
      currentTranslateX = -maxScrollLeft;
      track.style.transform = `translateX(${currentTranslateX}px)`;
    }
    updateSliderControls(maxScrollLeft);
  });

  // Runtime setup: initializes layouts visibility states on load
  const { maxScrollLeft } = getCarouselMetrics();
  updateSliderControls(maxScrollLeft);
});